import { ModalVisibilityProps } from 'sb-modal'
import { useCallback, useEffect } from 'sb-hooks'
import actions from 'redux/actions'
import { snowplow } from 'common/helpers'

import messages from './messages'


type UseGiftOfferConfirmModalProps = GiftOfferConfirmModal.ModalProps & ModalVisibilityProps


const useGiftOfferConfirmModal = (props: UseGiftOfferConfirmModalProps): GiftOfferConfirmModal.ReturnType & UseGiftOfferConfirmModalProps => {
  const { coupon, closeModal, onConfirm, onClose } = props

  const handleConfirm = useCallback(() => {
    actions.models.ui.showRequestLoader()

    snowplow.track('Stop unsubscribe', {
      type: 'stop unsubscribe',
    })

    actions.models.subscription.applyCoupon(coupon)
      .then(() => {
        if (typeof onConfirm === 'function') {
          onConfirm()
        }

        actions.misc.notifications.show('alert', {
          title: messages.notificationTitle,
        })
      })
      .finally(() => {
        actions.models.ui.hideRequestLoader()
        closeModal()
      })
  }, [ coupon, closeModal, onConfirm ])

  useEffect(() => {
    snowplow.track('UF offer popup confirmation', {
      type: 'stop unsubscribe',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    coupon,
    closeModal,
    onConfirm: handleConfirm,
    onClose,
  }
}


export default useGiftOfferConfirmModal
